import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot, getDocs, query } from 'firebase/firestore';
import { categoriesLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useCategoriesLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'categories' }));
    return onSnapshot(
      collection(db, 'categories'),
      async querySnapshot => {
        const categories = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          categories.push(dataItem);
        });

        await Promise.all(
          categories.map(async category => {
            const subCatSnapshop = await getDocs(
              query(collection(db, `categories/${category.id}/subcategories`))
            );

            const subcategories = [];
            subCatSnapshop.forEach(subCat => {
              subcategories.push(subCat.data());
            });

            category.subcategories = subcategories;
            return category;
          })
        );

        dispatch(categoriesLoadedAction(categories));
      },
      error => {
        console.error('useCategoriesLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadCategories: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useCategoriesLoader;
